module.exports = __webpack_public_path__ + "static/media/20ECE23.143f3896.jpg";